import type { ReactNode } from 'react';

/** État vide explicite : titre court + explication du futur contenu. */
export function EmptyState({ title, children }: { title: string; children: ReactNode }) {
  return (
    <div className="empty-state">
      <h3>{title}</h3>
      <p>{children}</p>
    </div>
  );
}
